
/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { ChartParms } from "@src/app/model/sys/nav-item";
import { Txn } from "@src/app/model/txn";
import { User } from "@src/app/model/user";
import { PurchasePageComponent } from "@src/app/modules/txn/purchase-page/purchase-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const PurchasePageNavRoute = new NavRoute(
    Txn.TYPE.PURCHASE.code, ()=>PurchasePageComponent, 'shopping_basket').setCharts([
        { type: 'bar', picklist: 'supplierId', number: 'credit', excludeZero: true } as ChartParms,
        { type: 'bar', picklist: 'txnCycleId', number: 'credit', excludeZero: true } as ChartParms,
        ]).setViews((u: User) => {
    return [
        {
            id: 'outstanding',
            name: 'All Outstanding',
            helpText: 'Purchase invoices with an outstanding balance',
            filterFields: {
                outstanding: '!=0.00',
                txnCycleId: null,
                txnPeriodId: null,
                supplierId: null,
                typeId: null,
            },
            sort: 'createdAt'
        },
        {
            id: 'unpaidUnApproved',
            name: 'Invoices for approval',
            helpText: 'Unpaid invoices awaiting approval',
            filterFields: {
                outstanding: '!=0.00',
                approvedAt: 'null',
                supplierId: null,
                typeId: null,
            },
            sort: 'createdAt'
        },
        {
            id: 'unpaidApproved',
            name: 'Approved Invoices',
            helpText: 'Approved invoices not yet paid',
            filterFields: {
                outstanding: '!=0.00',
                approvedAt: 'not null',
                supplierId: 'All',
                typeId: null,
            },
            sort: 'createdAt'
        },
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Purchase invoices for the current financial year; change the year filter to view a different year',
            filterFields: {
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
                txnPeriodId: 'All',
                supplierId: 'All',
                typeId: null,
            },
        }
    ]
});
